module.exports = __webpack_public_path__ + "static/img/Horticulturae 10.7d0dfb50.webp";